import { createFileRoute } from '@tanstack/react-router';
import { featureGuard } from 'router/featureGuard';
import { JwtFeature } from 'utility/jwt';

export const Route = createFileRoute(
  '/_authenticated/monitoring/realtime-productivity',
)({
  beforeLoad: featureGuard(JwtFeature.Realtime),
});
